import axios from "axios";
import {BASE_PATH} from "../services/api";

export const fetchCoefficients = async () => {
    return await axios.get(BASE_PATH + "/admin/get-coefficients", {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
};

export const updateCoefficients = async (formData) => {
    return await axios.post(
        BASE_PATH + "/admin/update-coefficient",
        formData,
        {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        }
    );
};
